import { feature } from 'topojson-client'
import topology from './geodata/switzerland.json'
import { GeojsonFeature } from 'types/GeojsonFeature'

const gemeinden = feature(topology, topology.objects.gemeinden)
export const indexedMunicipalityFeatures: Map<string, GeojsonFeature> = new Map(
  gemeinden.features.map((feature: GeojsonFeature) => [
    feature.properties['Primary_ID'],
    feature
  ])
)
